import { createFileRoute } from "@tanstack/react-router";
import { getCheckins } from "~/fetch/checkins";
import { CardsPage } from "~/components/CardsPage";

export const Route = createFileRoute('/varietal/$id/')({
  component: Component,
  loader: ({ params }) => {
    return getCheckins({ data: { page: 1, group: 'varietal', groupValue: params.id } });
  },
});

function Component() {
  const data = Route.useLoaderData();
  return <CardsPage data={data} />;
}
